export const LANG_KEY = "ga_ui_lang";

export function getUiLang() {
  return sessionStorage.getItem(LANG_KEY) === "ur" ? "ur" : "en";
}

export function setUiLang(lang) {
  sessionStorage.setItem(LANG_KEY, lang === "ur" ? "ur" : "en");
  window.dispatchEvent(new Event("ga-ui-lang"));
}
